/**
 * ciclo-cross-sell.js
 * ────────────────────
 * Fetches Shopify product recommendations for the cross-sell section
 * when no manual metafield cross-sells are set.
 *
 * The section renders with style="display:none". This script:
 * 1. Reads the product ID from data-product-id.
 * 2. Fetches /recommendations/products.json?product_id=X&limit=5.
 * 3. Filters out the current product.
 * 4. Builds minimal product cards (no Liquid — just HTML + price).
 * 5. Injects into .ciclo-cs__grid and shows the section.
 *
 * Note: for full card-product Liquid fidelity (badges, dealer pricing),
 * set the cross_sell_products metafield instead — that path renders
 * server-side via Liquid.
 */
(function () {
  'use strict';

  function init() {
    const section = document.getElementById('ciclo-cross-sell');
    if (!section || section.style.display !== 'none') return;

    const productId = section.dataset.productId;
    const limit     = parseInt(section.dataset.limit, 10) || 5;
    const grid      = section.querySelector('.ciclo-cs__grid');
    if (!productId || !grid) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const products = (data.products || []).filter(function (p) {
          return String(p.id) !== String(productId);
        }).slice(0, 4);

        if (products.length === 0) return;

        products.forEach(function (p) {
          grid.insertAdjacentHTML('beforeend', buildCard(p));
        });

        section.style.display = '';
      })
      .catch(function () { /* silent — section stays hidden */ });
  }

  function buildCard(p) {
    const v       = p.variants && p.variants[0];
    const price   = v ? formatMoney(v.price) : '';
    const cmp     = v && v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
    const imgSrc  = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]+)$/, '_400x400$1')
      : '';
    const imgTag  = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400" style="width:100%;height:auto;object-fit:cover;display:block;">'
      : '<div style="background:var(--ciclo-cream2);aspect-ratio:1;"></div>';
    const onSale  = cmp ? '<span class="badge badge--bottom-left color-inverse">Sale</span>' : '';
    const avail   = v && !v.available ? '<span class="badge badge--bottom-left color-sold-out">Sold Out</span>' : '';

    return '<div class="ciclo-cs__item card-wrapper product-card-wrapper">' +
      '<div class="card card--standard card--media">' +
        '<div class="card__inner ratio" style="--ratio-percent:100%">' +
          '<div class="card__media">' +
            '<a href="' + p.url + '" tabindex="-1" aria-hidden="true">' + imgTag + '</a>' +
          '</div>' +
          '<div class="card__content"><div class="card__badge bottom left">' + onSale + avail + '</div></div>' +
        '</div>' +
        '<div class="card__content">' +
          '<div class="card__information">' +
            (p.vendor ? '<div class="caption-with-letter-spacing light">' + esc(p.vendor) + '</div>' : '') +
            '<h3 class="card__heading h5"><a href="' + p.url + '" class="full-unstyled-link">' + esc(p.title) + '</a></h3>' +
            '<div class="card-information">' +
              '<div class="price' + (cmp ? ' price--on-sale' : '') + '">' +
                (cmp ? '<s class="price-item price-item--regular">' + cmp + '</s>' : '') +
                '<span class="price-item price-item--sale price-item--last">' + price + '</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function formatMoney(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
